import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH PROMOTION TO EDIT ********************
export const fetchPromotion = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PROMOTION_LOADING,
			payload: true
		});

		const { data } = await services.get(`/promotions/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PROMOTION_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PROMOTION_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
